/**
 * 模块: Keyword Score Columns
 * 职责: 关键词表格评分列定义（机会指数、集中度、流量质量等）
 * 限制: <280行
 */

import React from 'react';
import { Tooltip } from 'antd';
import type { ColumnType } from 'antd/es/table';
import { getPercentClass, metricSorter } from './columnUtils';

/**
 * 评分相关列（机会指数、集中度、流量质量、进入难度、更替率、稳定性）
 */
export const scoreColumns: ColumnType<any>[] = [
  {
    title: <Tooltip title="综合市场机会评估">机会指数</Tooltip>,
    dataIndex: ['metrics', 'market_opportunity'],
    key: 'market_opportunity',
    align: 'center',
    render: (value: number) => {
      if (value === null || value === undefined) return '-';
      const className = getPercentClass(value, { excellent: 70, good: 50, moderate: 30 });
      return (
        <Tooltip title="越高越好，综合评估市场机会的大小">
          <span className={`metric-value ${className}`}>{value.toFixed(1)}</span>
        </Tooltip>
      );
    },
    sorter: (a: any, b: any) => metricSorter(a, b, 'market_opportunity'),
  },
  {
    title: <Tooltip title="市场集中度评分">集中度</Tooltip>,
    dataIndex: ['metrics', 'market_concentration_score'],
    key: 'market_concentration_score',
    align: 'center',
    render: (value: number) =>
      value === null || value === undefined ? '-' : value.toFixed(1),
    sorter: (a: any, b: any) => metricSorter(a, b, 'market_concentration_score'),
  },
  {
    title: <Tooltip title="流量质量综合评分">流量质量</Tooltip>,
    dataIndex: ['metrics', 'traffic_quality_score'],
    key: 'traffic_quality_score',
    align: 'center',
    render: (value: number) =>
      value === null || value === undefined ? '-' : value.toFixed(1),
    sorter: (a: any, b: any) => metricSorter(a, b, 'traffic_quality_score'),
  },
  {
    title: <Tooltip title="进入该市场的难度">进入难度</Tooltip>,
    dataIndex: ['metrics', 'entry_barrier_score'],
    key: 'entry_barrier_score',
    align: 'center',
    render: (value: number, record: any) => {
      if (value === null || value === undefined) return '-';
      const detail = record.metrics?.entry_barrier;
      return (
        <span>
          {value.toFixed(1)}
          {detail?.level ? ` (${detail.level})` : ''}
        </span>
      );
    },
    sorter: (a: any, b: any) => metricSorter(a, b, 'entry_barrier_score'),
  },
  {
    title: <Tooltip title="品牌更替频率">更替率</Tooltip>,
    dataIndex: ['metrics', 'brand_turnover_rate'],
    key: 'brand_turnover_rate',
    align: 'center',
    render: (value: number) =>
      value === null || value === undefined ? '-' : `${(value * 100).toFixed(1)}%`,
    sorter: (a: any, b: any) => metricSorter(a, b, 'brand_turnover_rate'),
  },
  {
    title: <Tooltip title="市场稳定性指数">稳定性</Tooltip>,
    dataIndex: ['metrics', 'market_stability'],
    key: 'market_stability',
    align: 'center',
    render: (value: number) =>
      value === null || value === undefined ? '-' : `${(value * 100).toFixed(1)}%`,
    sorter: (a: any, b: any) => metricSorter(a, b, 'market_stability'),
  },
];

